/**
 * HostnamePreview — exibe par Publico/Canonical lado a lado.
 *
 * Usado em Step1 (so publico), Step2 (ambos) e Step4 (ambos no resumo).
 */
import { Box, Stack, Text } from '@mantine/core'

interface Props {
  publicHostname?: string | null
  canonicalHostname?: string | null
  showCanonical?: boolean
  compact?: boolean
}

export function HostnamePreview({
  publicHostname,
  canonicalHostname,
  showCanonical = true,
  compact = false,
}: Props) {
  if (!publicHostname && !canonicalHostname) return null

  return (
    <Box
      p={compact ? 'sm' : 'md'}
      style={{
        background: 'var(--mantine-color-blue-0, #f0f9ff)',
        borderRadius: 6,
        borderLeft: '3px solid var(--ai-brand-verde, #00a86b)',
      }}
    >
      <Stack gap={6}>
        {publicHostname ? (
          <div>
            <Text
              size="xs"
              tt="uppercase"
              fw={700}
              c="dimmed"
              style={{ letterSpacing: '0.06em' }}
            >
              Hostname público
            </Text>
            <Text
              size="sm"
              fw={600}
              c="var(--ai-brand-azul, #025468)"
              ff="JetBrains Mono, monospace"
            >
              {publicHostname}
            </Text>
          </div>
        ) : null}
        {showCanonical && canonicalHostname ? (
          <div>
            <Text
              size="xs"
              tt="uppercase"
              fw={700}
              c="dimmed"
              style={{ letterSpacing: '0.06em' }}
            >
              Hostname canonical (ZTNA)
            </Text>
            <Text size="xs" c="dimmed" ff="JetBrains Mono, monospace" style={{ wordBreak: 'break-all' }}>
              {canonicalHostname}
            </Text>
          </div>
        ) : null}
      </Stack>
    </Box>
  )
}
